import { Skeleton, Table } from "@mantine/core";


interface TableSkeletonRowsProps {
  columns: number;
  skeletonProps?: {
    height?: number;
    widths?: (number | "sm" | "md" | "lg")[]; // Array of widths for each column
    rightAlignLastColumn?: boolean;
  };
}

// Helper function to convert width keywords to numeric values
const getWidthValue = (width: number | "sm" | "md" | "lg"): number => {
  if (typeof width === "number") {
    return width;
  }

  switch (width) {
    case "sm":
      return 50;
    case "md":
      return 100;
    case "lg":
      return 180;
    default:
      return 100; // fallback to md
  }
};

export const TableSkeletonRows = ({
  columns = 1,
  skeletonProps,
}: TableSkeletonRowsProps) => {
  const defaultWidths = Array(columns).fill(100);
  const widths = skeletonProps?.widths || defaultWidths; // You don't need to specify all the widths individually when passing props,
  //  by default they will be "md"

  return Array(5)
    .fill(0)
    .map((_, index) => (
      <Table.Tr key={index}>
        {Array(columns)
          .fill(0)
          .map((_, colIndex) => (
            <Table.Td key={colIndex}>
              <Skeleton
                ml={
                  colIndex === columns - 1 &&
                  skeletonProps?.rightAlignLastColumn
                    ? "auto"
                    : 0
                }
                h={skeletonProps?.height || 25}
                w={getWidthValue(widths[colIndex])}
              />
            </Table.Td>
          ))}
      </Table.Tr>
    ));
};
